import './TypingDots.css';

/**
 * Bouncing dots animation — shown while the AI assistant is processing.
 * Reference: ChatGPT thinking indicator.
 */
function TypingDots() {
    return (
        <span className="typing-dots" aria-label="Chiefy is thinking" role="status">
            <span className="typing-dot" />
            <span className="typing-dot" />
            <span className="typing-dot" />
        </span>
    );
}

export default TypingDots;
